import { Button, ChevronLeftSVG, Icon } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { modalFooterCss } from "./CitationEditFormFooter.style";

interface CitationEditFormFooterProps {
  setShowEditForm: (showEditForm: boolean) => void;
  handleSubmit: () => void;
}

const ButtonWithTrackEvent = withTrackEvent(Button);

const CitationEditFormFooter = ({
  setShowEditForm,
  handleSubmit,
}: CitationEditFormFooterProps) => {
  return (
    <div css={modalFooterCss}>
      <ButtonWithTrackEvent
        flavor={Button.flavors.tertiary}
        actionName={actionNames.cancel}
        onClick={() => setShowEditForm(false)}
        objectType={objectTypes.generatedTextAsset}
        dataProps={{
          "data-qa-selector": "citation-edit-return-button",
        }}
      >
        <Icon SvgComponent={ChevronLeftSVG} />
        Cancel
      </ButtonWithTrackEvent>

      <ButtonWithTrackEvent
        flavor={Button.flavors.primary}
        actionName={actionNames.save}
        onClick={() => handleSubmit()}
        objectType={objectTypes.generatedTextAsset}
        dataProps={{
          "data-qa-selector": "citation-edit-save-button",
        }}
      >
        Save Edits
      </ButtonWithTrackEvent>
    </div>
  );
};

export default CitationEditFormFooter;
